/**
 * Parse a stored nameserver list (JSON array string). Tolerates NULL, the
 * legacy literal "null" and malformed values — anything else renders as no
 * nameservers instead of crashing the page.
 */
export function parseNameserverList(raw: string | null | undefined): string[] {
  if (!raw) return [];
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v.map(String).filter(Boolean) : [];
  } catch {
    return [];
  }
}
